export default function (host) {
  if (!host) {
    host = location.hostname;
  }
  host = host.toLowerCase();
  switch (host) {
    case 'abo.handelsblatt.com':
      return '357500119523122'; // old: return '461664817795478';
    case 'abo.wiwo.de':
      return '496847069983158';

    default:
      if(process.env === 'production') {
        console.warn('TrackID for ' + host + ' not exists. WT Disabled.');
        return false;
      }
      else {
        console.warn('TrackID for ' + host + ' not exists. WT USE DUMMY ID.');

        return '000000000000000';
      }
  }
}
